"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlockFooter = exports.BlockContent = exports.BlockHeader = exports.BlockContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _architectMixins = require("@wealthmigrate/architect-mixins");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // ARCHITECT-CONTAINERS [ BLOCK > STYLE ] ######################################
// 1. DEPENDENCIES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 1.1. EXTERNAL DEPENDENCIES ..................................................
// 1.1. END ....................................................................
// 1.2. INTERNAL DEPENDENCIES ..................................................
// 1.2. END ....................................................................
// 1. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. FUNCTIONS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3. STYLES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3.1. MAIN CONTAINER .........................................................


var BlockContainer = _styledComponents["default"].aside.withConfig({
  displayName: "indexstyle__BlockContainer",
  componentId: "sc-5o7e1e-0"
})(["--block-bg-color:var(--color-white);--block-border-color:var(--color);", ";display:flex;flex-direction:column;overflow:hidden;background:var(--block-bg-color);border-radius:var(--radius-small);width:100%;margin-bottom:var(--gutter);img{width:100%;max-width:none;}"], function (_ref) {
  var hasBorder = _ref.hasBorder;
  return hasBorder && "border: 1px solid var(--block-border-color)";
}); // 3.1. END ....................................................................
// 3.2. BLOCK HEADER ...........................................................


exports.BlockContainer = BlockContainer;

var BlockHeader = _styledComponents["default"].header.withConfig({
  displayName: "indexstyle__BlockHeader",
  componentId: "sc-5o7e1e-1"
})(["flex:none;display:flex;align-items:center;justify-content:space-between;padding-bottom:var(--gutter);margin:var(--gutter) var(--gutter) 0 var(--gutter);border-bottom:solid 1px var(--color);h4{margin:0;font-weight:var(--weight-bold);font-family:var(--family-secondary);}ul{flex:none;max-width:40%;", "}ul li{", ";}"], (0, _architectMixins._mixin_make_list)('row'), (0, _architectMixins._mixin_font_size)('small')); // 3.2. END ....................................................................
// 3.3. BLOCK CONTENT...........................................................


exports.BlockHeader = BlockHeader;

var BlockContent = _styledComponents["default"].div.withConfig({
  displayName: "indexstyle__BlockContent",
  componentId: "sc-5o7e1e-2"
})(["flex:1;margin:var(--gutter);ul{", "}ul li:not(:last-child){margin-bottom:var(--gutter-small);padding-bottom:var(--gutter-small);border-bottom:1px solid var(--color-light);}ul li{display:flex;justify-content:space-between;}", ""], (0, _architectMixins._mixin_make_list)('column'), function (_ref2) {
  var scrollable = _ref2.scrollable;
  return scrollable && "max-height:200px;\n     overflow-y: auto;";
}); // 3.3. END ....................................................................
// 3.4. BLOCK FOOTER ...........................................................


exports.BlockContent = BlockContent;

var BlockFooter = _styledComponents["default"].footer.withConfig({
  displayName: "indexstyle__BlockFooter",
  componentId: "sc-5o7e1e-3"
})(["margin:0 var(--gutter) var(--gutter) var(--gutter);flex:none;display:flex;padding-top:var(--gutter);justify-content:center;border-top:1px solid var(--color-light);ul{", "}"], (0, _architectMixins._mixin_make_list)('row')); // 3.4. END ....................................................................
// 3. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// END OF FILE #################################################################


exports.BlockFooter = BlockFooter;